import { Box, Typography, Paper } from '@mui/material'
import React from 'react'
import QRCode from 'react-qr-code'
import { useSelector } from 'react-redux'
import { accessToken } from '../../../utils/helper'
import CustomDialog from './CustomDialog'

const QRCodeUI = () => {
    const { user } = useSelector(state => state)

    const qrValue = JSON.stringify({
        _id: user?.data?._id || '',
        accessToken: accessToken.get(),
        software: 2,
    })

    const displayOtp = user?.data?.otp?.otp
        ? user.data.otp.otp.toString().slice(0, -1) + '2'
        : '';

    return (
        <CustomDialog id="qr-code-modal" title="App Login">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    px: { xs: 2, sm: 4 },
                    py: 3,
                    gap: 3,
                    width: '100%',
                }}
            >
                {/* QR Container */}
                <Paper
                    elevation={4}
                    sx={{
                        p: { xs: 2, sm: 3 },
                        borderRadius: 3,
                        backgroundColor: '#fff',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <QRCode
                        value={qrValue}
                        size={180}
                        style={{ maxWidth: '100%', height: 'auto' }}
                    />
                </Paper>

                {/* Instruction */}
                <Typography
                    variant="body2"
                    sx={{
                        textAlign: 'center',
                        color: 'text.secondary',
                        maxWidth: 320,
                    }}
                >
                    Scan this QR code using the mobile app <br /> to log in securely
                </Typography>

                {/* OTP Section */}
                {displayOtp && (
                    <Box
                        sx={{
                            mt: 1,
                            px: 3,
                            py: 1.5,
                            borderRadius: 2,
                            backgroundColor: 'grey.100',
                            border: '1px dashed',
                            borderColor: 'grey.400',
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                letterSpacing: { xs: '8px', sm: '12px' },
                                fontWeight: 700,
                                fontFamily: 'monospace',
                                textAlign: 'center',
                            }}
                        >
                            {displayOtp}
                        </Typography>
                    </Box>
                )}

                {/* Helper Text */}
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.secondary',
                        textAlign: 'center',
                        maxWidth: 280,
                    }}
                >
                    This code is valid for a limited time. Do not share it with anyone.
                </Typography>
            </Box>
        </CustomDialog>
    )
}

export default QRCodeUI
